import React /*, { seState, useEffect, useContext }*/ from 'react';
import AfitdTypography from '../../common/elemental/AfitdTypography';

const PlaceholderText = props => {
    const { value = '' } = props;
    return <AfitdTypography variant="body2" clsGrayColor={true} value={value} style={{ lineHeight: '16px' }} />;
};

export default PlaceholderText;
